import { render, staticRenderFns } from "./TmdbAttribution.vue?vue&type=template&id=79fddf9a&scoped=true&"
import script from "./TmdbAttribution.vue?vue&type=script&lang=js&"
export * from "./TmdbAttribution.vue?vue&type=script&lang=js&"
import style0 from "./TmdbAttribution.vue?vue&type=style&index=0&id=79fddf9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fddf9a",
  null
  
)

export default component.exports